import { render, staticRenderFns } from "./PopupDataInvalid.vue?vue&type=template&id=41357120"
import script from "./PopupDataInvalid.vue?vue&type=script&lang=js"
export * from "./PopupDataInvalid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports